module.exports = __webpack_public_path__ + "img/Leitstelle.a4abf6e8.svg";